module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/667c72a022edc70581e65852f5d95ad8.png";